import React from 'react';
import Header from './Header';
import Hero from './Hero';
import About from './About';
import Services from './Services';
import Anos30 from './Anos30';
import News from './News';
import Clients from './Clients';
import Team from './Team';
import Contact from './Contact';
import Footer from './Footer';

const HomePage = () => {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Anos30 />
        <News />
        <Clients />
        <Team />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

export default HomePage;
